import React from 'react';

const About = () => {
  return (
    <div className="section about">
      <div className="container">
        <h2 className="section_title about_title color-red">Your money is safe here</h2>
        <div className="about_text">
          Openbank is a division of Santander Bank, N.A. Member FDIC. Verizon and its affiliates are not FDIC insured
          <br /> { ' ' }
          institutions. All deposits are held at Santander Bank, N.A. Deposits at Santander Bank, N.A. and its Openbank
          <br /> { ' ' }
          division are combined for FDIC insurance purposes (FDIC Cert. 29950) and are not separately insured. There is a
          <br /> { ' ' }
          maximum of $250,000 of deposit insurance from the FDIC per depositor for each category of account ownership.
          <br /> { ' ' }
          Please visit FDIC.gov for details. Verizon is not a chartered banking institution and is not insured by FDIC.
        </div>
        <div className="about_logo">
          <svg className="icon -openbank-logo">
            <use xlinkHref="#svg_openbank-logo" />
          </svg>
        </div>
        <div className="about_decor">
          <div className="decor-squares -center -red" />
        </div>
      </div>
    </div>
  );
};

export default About;
